<div class="container checkout-container">
  @if (!isSeller) {
    <app-button (btnClick)="goToAddressSection()" styleType="clean">
      <i class="fas fa-arrow-left me-1"></i> Voltar para endereço
    </app-button>
  }
  <p class="h4 mb-0">Pagamento</p>
  <div class="row">
    <div class="checkout-container">
      @if (showPaymentMethods) {
        <section class="payment-method pb-2">
          <p class="h5">Método de Pagamento</p>
          <div class="container-payment-methods">
            @if (canUsePix) {
              <app-button
                (btnClick)="changePaymentMethod('pix')"
                [styleType]="paymentMethod.value === 'pix' ? 'primary' : 'outlined'">
                Pix
              </app-button>
            }
            @if (isSeller) {
              <app-button
                (btnClick)="changePaymentMethod('payment_link')"
                [styleType]="paymentMethod.value === 'payment_link' ? 'primary' : 'outlined'">
                Link (Cartão)
              </app-button>
              <app-button
                (btnClick)="changePaymentMethod('cash')"
                [styleType]="paymentMethod.value === 'cash' ? 'primary' : 'outlined'">
                Dinheiro
              </app-button>
            } @else {
              <app-button
                (btnClick)="changePaymentMethod('credit_card')"
                [styleType]="paymentMethod.value === 'credit_card' ? 'primary' : 'outlined'">
                Cartão de Crédito
              </app-button>
            }
          </div>
          @if (!isSeller) {
            <label class="combine-toggle">
              <input
                type="checkbox"
                [checked]="combineTwoMethods"
                (change)="toggleCombineTwoMethods($any($event.target).checked)" />
              <span>Combinar 2 meios de pagamento</span>
            </label>
            @if (combineTwoMethods) {
              <div class="container-payment-methods combine-combo-options">
                @if (canUsePix) {
                  <app-button
                    (btnClick)="selectSplitCombo('pix_credit_card')"
                    [styleType]="paymentMethod.value === 'pix_credit_card' ? 'primary' : 'outlined'">
                    Pix + Cartão
                  </app-button>
                }
                <app-button
                  (btnClick)="selectSplitCombo('two_credit_cards')"
                  [styleType]="paymentMethod.value === 'two_credit_cards' ? 'primary' : 'outlined'">
                  2 Cartões
                </app-button>
              </div>
            }
          }
        </section>
      }

      <!-- Spinner sempre visível quando necessário -->
      @if (shouldShowProcessingIndicator()) {
        <div class="container-spinner">
          <p-progressSpinner ariaLabel="loading" />
          <div class="payment-status-message">
            <p class="status-text">{{ getPaymentStatusText() }}</p>
            @if (isWebSocketConnected) {
              <small class="connection-indicator">🔗 Conectado</small>
            } @else {
              <small class="connection-indicator">🔄 Reconectando...</small>
            }
          </div>
        </div>
      }

      <!-- Formulário sempre visível, mas com overlay quando processando -->
      <div class="form-container" [class.processing]="loading || shouldShowProcessingIndicator()">
        @if (showCreditCardForm && !splitAwaitingPix) {
          @if (
            paymentMethod.value === "credit_card" ||
            paymentMethod.value === "pix_credit_card" ||
            paymentMethod.value === "two_credit_cards"
          ) {
            <section class="credit-card-data">
              <div class="credit-card-checkout">
                <form [formGroup]="cardForm" (ngSubmit)="onCreditCardPay()" novalidate>
                  @if (isSplitPayment) {
                    <section class="split-payment-amounts mb-3">
                      <p class="h5">Como deseja dividir?</p>
                      <p class="text-muted small mb-3">
                        @if (paymentMethod.value === "pix_credit_card") {
                          O cartão é cobrado primeiro (à vista). Depois, pague o Pix do restante.
                        } @else {
                          Informe o valor do 1º cartão. O restante vai para o 2º (ambos à vista).
                        }
                      </p>
                      <div class="checkout__row">
                        <label for="splitFirstAmount">Valor no {{ splitFirstMethodLabel }} (R$)</label>
                        <input
                          id="splitFirstAmount"
                          type="number"
                          class="form-control"
                          min="1"
                          step="0.01"
                          [(ngModel)]="splitFirstAmountReais"
                          [ngModelOptions]="{ standalone: true }"
                          [attr.max]="orderTotal - 1" />
                      </div>
                      <div class="split-amount-chips">
                        <button type="button" class="split-chip" (click)="applySplitHalf()">Metade</button>
                        <button
                          type="button"
                          class="split-chip"
                          (click)="applySplitAmount(orderTotal * 0.3)">
                          30%
                        </button>
                        <button
                          type="button"
                          class="split-chip"
                          (click)="applySplitAmount(orderTotal * 0.7)">
                          70%
                        </button>
                      </div>
                      <div
                        class="split-remaining"
                        [class.split-remaining--invalid]="!splitFirstAmountValid">
                        <span class="split-remaining__label">Falta pagar</span>
                        <strong class="split-remaining__value">
                          {{ splitRemainingReais | currency: "BRL" }}
                        </strong>
                        <span class="split-remaining__method">
                          no {{ splitSecondMethodLabel }} (1x)
                        </span>
                      </div>
                      @if (!splitFirstAmountValid) {
                        <p class="text-danger small mt-2" role="alert">
                          Cada meio deve ter pelo menos R$ 1,00. Para dividir, o total deve ser de pelo menos R$ 2,00.
                        </p>
                      }
                    </section>
                  }
                  <p class="h5">
                    {{ paymentMethod.value === "two_credit_cards" ? "1º Cartão" : "Dados do Cartão" }}
                  </p>
                  @if (useNewCard || savedCards.length === 0) {
                    <!-- Formulário de novo cartão -->
                    <div>
                      @if (savedCards.length > 0) {
                        <!-- Botão para voltar aos cartões salvos -->
                        <div class="mb-3">
                          <app-button type="button" class="p-0" (btnClick)="useNewCard = false; selectedCardId = null">
                            <i class="fas fa-arrow-left me-1"></i>
                            Voltar aos cartões salvos
                          </app-button>
                        </div>
                      }
                      <!-- Componente de Cartão Interativo -->
                      <div class="mb-4">
                        <app-credit-card
                          [cardData]="creditCardData"
                          [isFlipped]="isCardFlipped"
                          [readonly]="false"
                          (cardDataChange)="onCreditCardDataChange($event)"
                          (flipCard)="onCardFlip()"
                          (focusCvv)="onCvvFocus()">
                        </app-credit-card>
                      </div>
                      <!-- Campos ocultos para sincronização com o formulário -->
                      <input type="hidden" formControlName="holder_name" />
                      <input type="hidden" formControlName="card_number" />
                      <input type="hidden" formControlName="expiry_month" />
                      <input type="hidden" formControlName="expiry_year" />
                      <input type="hidden" formControlName="cvv" />
                      @if (paymentMethod.value === "credit_card") {
                        <div class="checkout__row">
                          <label for="installments">Parcelas</label>
                          <p-select
                            inputId="installments"
                            formControlName="installments"
                            [options]="installmentSelectOptions"
                            optionLabel="label"
                            optionValue="value"
                            [loading]="!installmentSelectOptions.length"
                            placeholder="Carregando parcelas..."
                            emptyMessage="Carregando parcelas..."
                            appendTo="body" />
                        </div>
                      }
                    </div>
                  } @else {
                    <app-credit-card-wallet [savedCards]="savedCards" [(selectedCard)]="selectedCard" />
                    @if (paymentMethod.value === "credit_card") {
                      <div class="checkout__row">
                        <label for="installments-saved">Parcelas</label>
                        <p-select
                          inputId="installments-saved"
                          formControlName="installments"
                          [options]="installmentSelectOptions"
                          optionLabel="label"
                          optionValue="value"
                          [loading]="!installmentSelectOptions.length"
                          placeholder="Carregando parcelas..."
                          emptyMessage="Carregando parcelas..."
                          appendTo="body" />
                      </div>
                    }
                    <app-button type="button" (btnClick)="useNewCard = true; selectedCardId = null">
                      <i class="fas fa-plus me-1"></i>
                      Usar novo cartão
                    </app-button>
                  }
                </form>

                @if (paymentMethod.value === "two_credit_cards") {
                  <div class="mt-4" [formGroup]="secondCardForm">
                    <p class="h5">2º Cartão</p>
                    @if (useNewSecondCard || savedCards.length === 0) {
                      <div>
                        @if (savedCards.length > 0) {
                          <div class="mb-3">
                            <app-button
                              type="button"
                              class="p-0"
                              (btnClick)="useNewSecondCard = false; selectedSecondCard = undefined">
                              <i class="fas fa-arrow-left me-1"></i>
                              Voltar aos cartões salvos
                            </app-button>
                          </div>
                        }
                        <div class="mb-4">
                          <app-credit-card
                            [cardData]="creditCardDataSecond"
                            [isFlipped]="isSecondCardFlipped"
                            [readonly]="false"
                            (cardDataChange)="onSecondCreditCardDataChange($event)"
                            (flipCard)="onSecondCardFlip()"
                            (focusCvv)="onSecondCvvFocus()">
                          </app-credit-card>
                        </div>
                        <input type="hidden" formControlName="holder_name" />
                        <input type="hidden" formControlName="card_number" />
                        <input type="hidden" formControlName="expiry_month" />
                        <input type="hidden" formControlName="expiry_year" />
                        <input type="hidden" formControlName="cvv" />
                      </div>
                    } @else {
                      <app-credit-card-wallet
                        [savedCards]="savedCards"
                        [(selectedCard)]="selectedSecondCard"
                        title="Selecione o 2º cartão" />
                      <app-button type="button" (btnClick)="useNewSecondCard = true; selectedSecondCard = undefined">
                        <i class="fas fa-plus me-1"></i>
                        Usar novo cartão
                      </app-button>
                    }
                  </div>
                }

                @if (cardStatusMsg) {
                  <div
                    class="status-banner"
                    [class.ok]="cardStatusOk"
                    [class.error]="!cardStatusOk"
                    [attr.role]="cardStatusOk ? 'status' : 'alert'"
                    [attr.aria-live]="cardStatusOk ? 'polite' : 'assertive'">
                    <span class="status-icon" aria-hidden="true">
                      @if (cardStatusOk) {
                        <svg viewBox="0 0 24 24" width="20" height="20">
                          <path
                            d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2Zm-1 14-4-4 1.414-1.414L11 12.172l4.586-4.586L17 9l-6 7Z" />
                        </svg>
                      } @else {
                        <svg viewBox="0 0 24 24" width="20" height="20">
                          <path d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2Zm1 14h-2v-2h2v2Zm0-4h-2V6h2v6Z" />
                        </svg>
                      }
                    </span>
                    <div class="status-text">
                      <p class="status-message">{{ cardStatusMsg }}</p>
                    </div>
                  </div>
                }
              </div>
            </section>
          }
        }

        @if (splitAwaitingPix) {
          <div class="split-remaining split-remaining--pending mb-3">
            <span class="split-remaining__label">Pagamento pendente · Falta pagar</span>
            <strong class="split-remaining__value">
              {{ splitAwaitingPixAmountReais | currency: "BRL" }}
            </strong>
            <span class="split-remaining__method">no Pix para concluir o pedido</span>
            <p class="split-remaining__hint mb-0 mt-2">
              Se não concluir, o pedido permanece pendente. Você pode pedir o estorno do valor já pago em Meus Pedidos.
            </p>
            <div class="mt-2">
              <app-button styleType="outlined" (btnClick)="goToMyOrdersPending()">
                Ir para Meus Pedidos
              </app-button>
            </div>
          </div>
        }

        @if (splitAwaitingSecondCard) {
          <section class="split-payment-amounts mb-3">
            <div class="split-remaining split-remaining--pending mb-3">
              <span class="split-remaining__label">Pagamento pendente · Falta pagar</span>
              <strong class="split-remaining__value">
                {{ remainingPaymentReais | currency: "BRL" }}
              </strong>
              <span class="split-remaining__method">com outro cartão</span>
              <p class="split-remaining__hint mb-0 mt-2">
                Uma parte já foi aprovada. Finalize com outro cartão ou peça o estorno em Meus Pedidos se não puder concluir.
              </p>
            </div>
            <p class="h5">Cartão para o valor restante</p>
            <div [formGroup]="secondCardForm">
              @if (useNewSecondCard || savedCards.length === 0) {
                <div class="mb-4">
                  <app-credit-card
                    [cardData]="creditCardDataSecond"
                    [isFlipped]="isSecondCardFlipped"
                    [readonly]="false"
                    (cardDataChange)="onSecondCreditCardDataChange($event)"
                    (flipCard)="onSecondCardFlip()"
                    (focusCvv)="onSecondCvvFocus()">
                  </app-credit-card>
                </div>
                <input type="hidden" formControlName="holder_name" />
                <input type="hidden" formControlName="card_number" />
                <input type="hidden" formControlName="expiry_month" />
                <input type="hidden" formControlName="expiry_year" />
                <input type="hidden" formControlName="cvv" />
              } @else {
                <app-credit-card-wallet
                  [savedCards]="savedCards"
                  [(selectedCard)]="selectedSecondCard"
                  title="Selecione o cartão" />
                <app-button type="button" (btnClick)="useNewSecondCard = true; selectedSecondCard = undefined">
                  Usar novo cartão
                </app-button>
              }
            </div>
            @if (cardStatusMsg) {
              <p class="text-danger mt-2">{{ cardStatusMsg }}</p>
            }
            <div class="d-flex flex-column gap-2 mt-3">
              <app-button
                styleType="success"
                class="w-100"
                [disabled]="remainingCardProcessing"
                (btnClick)="payRemainingWithCard()">
                {{ remainingCardProcessing ? "Processando..." : "Finalizar valor restante" }}
              </app-button>
              <app-button styleType="outlined" class="w-100" (btnClick)="goToMyOrdersPending()">
                Pedir estorno / ver pedido
              </app-button>
            </div>
          </section>
        }

        @if (
          !isSeller &&
          !isFreeOrder &&
          canUsePix &&
          (paymentMethod.value === "pix" || splitAwaitingPix)
        ) {
          <app-pix-section
            [pixData]="pixData$ | async | mapPixResponse"
            [loading]="loading"
            [statusPaymentPix]="statusPaymentPix"
            [isWebSocketConnected]="isWebSocketConnected"
            [showInternationalHint]="!isBrazilianCustomer"
            [canGenerateQr]="canGeneratePixQr && paymentMethod.value === 'pix'"
            (generateQrCodeClick)="generatePixPayment()" />
        }

        @if (isSeller && canUsePix && paymentMethod.value === "pix") {
          <app-seller-pix-checkout
            [pixData]="sellerPixData"
            [loading]="loading"
            [statusPaymentPix]="statusPaymentPix"
            [isWebSocketConnected]="isWebSocketConnected"
            [detailsSuppressed]="suppressSellerInlinePaymentDetails"
            [showInternationalHint]="clientInfo.is_foreign_client"
            [canGenerateQr]="canGeneratePixQr"
            (generateChargeClick)="generateSellerPixCharge()" />
        }

        @if (isSeller && paymentMethod.value === "payment_link") {
          <app-seller-link-checkout
            [paymentLinkUrl]="sellerPaymentLinkUrl"
            [loading]="loading"
            [statusPaymentPix]="statusPaymentPix"
            [isWebSocketConnected]="isWebSocketConnected"
            [detailsSuppressed]="suppressSellerInlinePaymentDetails"
            (generateLinkClick)="generateSellerPaymentLink()" />
        }

        @if (isSeller && paymentMethod.value === "cash") {
          <section class="seller-cash-data">
            <p class="h5">Pagamento em Dinheiro</p>
            <p class="text-muted">Registre a venda somente após receber o valor em dinheiro no ponto de venda.</p>
            <app-button (btnClick)="confirmSellerCashSale()" [disabled]="loading" styleType="success">
              {{ loading ? "Registrando venda..." : "Registrar venda em dinheiro" }}
            </app-button>
          </section>
        }

        @if (isSeller && suppressSellerInlinePaymentDetails && !isSellerPaymentModalOpen) {
          <div class="border rounded-3 p-3 mb-3 border-secondary-subtle" role="status">
            <p class="mb-2 small text-muted">
              Há uma cobrança ativa. Abra o painel para ver QR, copia e cola, link e o status do pagamento.
            </p>
            <app-button styleType="outlined" (btnClick)="reopenSellerPaymentDialog()">
              Abrir painel de cobrança
            </app-button>
          </div>
        }

        @if (shouldShowSuccessMessage() || shouldShowErrorMessage()) {
          <div class="status-container">
            @if (shouldShowSuccessMessage()) {
              <div class="status-banner success">
                <div class="status-icon">
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <path
                      d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2Zm-1 14-4-4 1.414-1.414L11 12.172l4.586-4.586L17 9l-6 7Z" />
                  </svg>
                </div>
                <div class="status-content">
                  <h3>Pagamento Aprovado!</h3>
                  <p>{{ paymentStatusMessage }}</p>
                </div>
              </div>
            }
          </div>
        }

        <!-- @if (!pixQrCodeUrl) { -->
        <div class="mt-3">
          @if (isFreeOrder && !isSeller) {
            <app-button styleType="success" [disabled]="loading" (btnClick)="finalizeFreeOrder()" class="w-100">
              {{ loading ? "Finalizando..." : "Finalizar compra" }}
            </app-button>
          } @else if (showCreditCardForm && !splitAwaitingPix && !splitAwaitingSecondCard) {
            <app-button
              styleType="success"
              (btnClick)="onCreditCardPay()"
              [disabled]="cardProcessing || (isSplitPayment && !splitFirstAmountValid)"
              class="w-100">
              @if (!cardProcessing) {
                <span>
                  {{
                    paymentMethod.value === "pix_credit_card"
                      ? "Pagar cartão e gerar Pix"
                      : paymentMethod.value === "two_credit_cards"
                        ? "Pagar com 2 cartões"
                        : "Finalizar compra"
                  }}
                </span>
              }
              @if (cardProcessing) {
                <span class="spinner" aria-label="Processando..."></span>
              }
            </app-button>
          } @else if (!isSeller && !splitAwaitingPix) {
            <app-button styleType="success" [disabled]="this.loading || !selectedCard" (btnClick)="onSubmit()">
              {{ this.loading ? "Carregando..." : "Finalizar Compra" }}
            </app-button>
          }
        </div>
        <!-- } -->
      </div>
    </div>
  </div>
</div>

<!-- Payment Processing Overlay -->
<app-payment-processing-overlay
  [isVisible]="showPaymentOverlay"
  [currentStep]="currentPaymentStep"
  [errorMessage]="paymentOverlayError"
  [paymentMethod]="overlayPaymentMethod"
  (closeOverlayClick)="showPaymentOverlay = false" />
